module.exports = __webpack_public_path__ + "FixelDisplay-ThinItalic-1e39574ce2fda9b254565afa327b6c8b.woff2";